import { AddressListView, AddressSection } from "./AddressListView";
import { useClientAddresses } from "./useClientAddresses";

interface AddressListProps {
  clientId?: number;
  /** Query do cliente a invalidar quando o legado muda (padrão de cobrança). */
  clientQueryKey?: readonly unknown[];
}

const SECTIONS: AddressSection[] = [
  {
    type: "Billing",
    title: "Endereço de cobrança",
    description: "O padrão de cobrança é o endereço do cadastro do cliente, usado hoje nos pedidos.",
  },
  {
    type: "Shipping",
    title: "Endereço de entrega",
    description: "Endereços para entrega dos pedidos.",
  },
];

const SHIPPING_HINT =
  "Ao realizar o pedido, a escola escolhe um destes endereços (o padrão já vem marcado). A previsão de entrega usa a UF do endereço escolhido.";

/** Endereços do cliente CNPJ agrupados por finalidade, com selo de padrão e as ações de cada endereço. */
export function AddressList({ clientId, clientQueryKey }: AddressListProps) {
  const book = useClientAddresses(clientId, clientQueryKey);
  return (
    <AddressListView
      book={book}
      sections={SECTIONS}
      shippingHint={SHIPPING_HINT}
      errorMessage="Não foi possível carregar os endereços do cliente."
    />
  );
}
